import { useConfig } from './useConfig'

export const useResumeReviewFeatureConfig = () => {
  const config = useConfig()

  const aiResumeReviewABTestVariant = config?.features?.rbpAiReview || 'v0'
  const isAiResumeReviewFeatureActive = ['v1', 'v2'].includes(aiResumeReviewABTestVariant)

  return {
    isAiResumeReviewFeatureActive,
    aiResumeReviewABTestVariant,
  }
}
